//Archivo dedicado al menu de todos los imports de FORSETI

//Imports relacionados de FORSETI
//-----------Principal-----------
import Plantilla from '@/components/SISETA/Comun/Plantilla.vue';


//Se crea la lista de paths
const SISETA = [
  { path: '/SISETA', component: Plantilla }
]

//Se regresa la lista de paths
export default SISETA;



// WEBPACK FOOTER //
// ./src/router/SISETA.js